import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import ListStarProcess from "./components/commentStarProgress/ListStarProgress";
import { Row, Col, Modal, message, Typography, notification } from "antd";
import "./css/commentGlobal.css";
import CommentList from "./components/list/CommentList";
import CommentForm from "./components/commentForm.tsx/CommentForm";
import { selectToken, toggleShowLogin } from "features/auth/AuthSlice";
import { useGetReviewListPublicQuery } from "./service/comment.service";
import { CheckCircleOutlined, RightOutlined } from "@ant-design/icons";
import CommentSwiper from "./components/commentSwiper/CommentSwiper";
// import { Cookies, useCookies } from "react-cookie";
import ImageModel from "common/models/ImageModel";
import { FilterImage } from "./types/gallery.type";
import { ConverErrorFetch } from "./types/comment.type";
import { isEntityError, isFetchError } from "common/utils/errorResultRTK";
import QaList from "./components/list/QaList";
import { CommentJson } from "./types/comment.type";
import CommentReviewItem from "./components/commentGallery/CommentReviewItem";
import ReviewDetail, {
	ReviewDetailList,
} from "./components/commentDetail/ReviewDetail";
import { setlistReviewGalley } from "./CommentSlice";
import CommentGallery from "./components/commentGallery/commentGallery";
import Login from "features/auth/pages/Login";
import CurrentRated from "features/comment/components/totalReviewRated/CurrentRated";
const Comment = () => {
	const [messageApi, contextHolder] = message.useMessage();
	const [api, contextHolderNoti] = notification.useNotification();
	const token = useAppSelector(selectToken);
	const dispatch = useAppDispatch();

	/////////////////////////////////////
	// default Filters
	const [filters, setFilters] = useState<FilterImage>({
		...ImageModel.getDefaultFilter(),
	});

	/////////////////////////////////////
	const [showQa, setShowQa] = useState<boolean>(false);
	const [showReview, setShowReview] = useState<boolean>(false);
	const [showReviewDetail, setShowReviewDetail] = useState(false);
	const [showGallery, setShowGallery] = useState<boolean>(false);
	const [defaultSlideReview, setDefaultSlideReview] = useState(0);

	//
	const product_id = useAppSelector((state) => state.comment.product_id);
	const item_type = useAppSelector((state) => state.comment.type);
	const showLogin = useAppSelector((state) => state.auth.showLogin);

	/////////////////////////////////////
	const {
		data: galleyReview,
		error: galleyError,
		refetch,
	} = useGetReviewListPublicQuery({
		...filters,
		item_type: item_type,
		status: 1,
		item_id:
			typeof product_id === "string" ? product_id : JSON.stringify(product_id),
		limit: 50,
		sort_by: "date_created",
		sort_type: "DESC",
	});

	/////////////////////////////////////
	// convert error when get list
	const erorrFetchGalley = useMemo((): ConverErrorFetch | undefined => {
		if (isEntityError(galleyError)) {
			return {
				status: galleyError.status,
				errors: galleyError.data.error,
			};
		} else if (isFetchError(galleyError)) {
			return {
				status: galleyError.status,
				errors: [galleyError.error],
			};
		}
	}, [galleyError]);

	// const erorrFetchReview = useMemo((): ConverErrorFetch | undefined => {
	//   if (isEntityError(errorReview)) {
	//     return {
	//       status: errorReview.status,
	//       errors: errorReview.data.error,
	//     };
	//   } else if (isFetchError(errorReview)) {
	//     return {
	//       status: errorReview.status,
	//       errors: [errorReview.error],
	//     };
	//   }
	// }, [errorReview]);

	//

	// const [cookies, setCookie, removeCookie] = useCookies(["token"]);
	// setCookie("token", "sfasdkfjaskfjsaj98913ksjf", {
	//   path: "/",
	//   maxAge: 1,
	//   domain: ".beme.vn",
	//   secure: true,
	// });
	//

	// function

	const handleTranslateMessage = (type: string): string => {
		let message = "";
		switch (type) {
			case "comment":
				message = "Cảm ơn bạn đã để lại bình luận !";
				break;
			case "review":
				message = "Cảm ơn bạn đã để lại đánh giá !";
				break;
			case "qa":
				message = "Cảm ơn bạn đã gửi câu hỏi !";
				break;
			default:
				break;
		}
		return message;
	};

	const handleSuccesQa = (type: string) => {
		messageApi.open({
			content: (
				<span style={{ margin: 0, fontWeight: 700, fontSize: "14px" }}>
					{handleTranslateMessage(type)}
				</span>
			),
			duration: 2,
			type: "success",
			icon: (
				<CheckCircleOutlined
					// size={40}
					style={{
						width: "40px",
						height: "40px",
						fontSize: "40px",
						color: "#D72229",
					}}
				/>
			),
			className: "success_form",
			style: {
				marginTop: "calc(50vh - 93px)",
			},
		});
		setShowQa(false);
	};

	const handleSuccesReview = (type: string) => {
		messageApi.open({
			content: (
				<span style={{ margin: 0, fontWeight: 700, fontSize: "14px" }}>
					{handleTranslateMessage(type)}
				</span>
			),
			duration: 1,
			type: "success",
			icon: (
				<CheckCircleOutlined
					// size={40}
					style={{
						width: "40px",
						height: "40px",
						fontSize: "40px",
						color: "#D72229",
					}}
				/>
			),
			className: "success_form",
			style: {
				marginTop: "calc(50vh - 93px)",
			},
		});
		setShowReview(false);
	};

	const handleShowGallery = (flag: boolean) => {
		setShowGallery(flag);
	};

	const handleShowReviewDetail = useCallback(
		(index: number, indexImg: number) => {
			setShowReviewDetail(true);
			setDefaultSlideReview(index);
		},
		[showReviewDetail, defaultSlideReview]
	);

	const handleRevertIndexImage = (
		index: number,
		id: number,
		arr: CommentJson[]
	) => {
		const newArr = arr.slice(0, index);
		const number = newArr.reduce((acc, item) => {
			if (item.id === id) {
				acc += 1;
			}
			return acc;
		}, 0);

		return number;
	};

	////////////////////////////////
	const dataReviewDetail = useMemo(() => {
		let newData: CommentJson[] = [];
		if (galleyReview) {
			const review_list = galleyReview.items.filter(
				(review) => review.images.length > 0
			);
			if (review_list.length >= 7) {
				newData = [...review_list];
			} else {
				review_list.forEach((item) => {
					item.images.forEach((img) => {
						newData.push(item);
					});
				});
			}
		}
		return newData;
	}, [galleyReview]);

	const dataReviewDetailActive = useMemo(() => {
		let newData: ReviewDetailList[] = [];
		if (galleyReview) {
			const review_list = galleyReview.items.filter(
				(review) => review.images.length > 0
			);
			if (review_list.length >= 7) {
				review_list.forEach((item) => {
					item.images.forEach((img, index) => {
						newData.push({ activeImage: index, ...item });
					});
				});
				// review_list.forEach((item, index) => {
				//   newData.push({ activeImage: 0, ...item });
				// });
			} else {
				review_list.forEach((item) => {
					item.images.forEach((img, index) => {
						newData.push({ activeImage: index, ...item });
					});
				});
			}
		}
		return newData;
	}, [galleyReview]);

	const dataReviewDefault = useMemo(() => {
		let newData: CommentJson[] = [];
		if (galleyReview) {
			const review_list = galleyReview.items.filter(
				(review) => review.images.length > 0
			);
			newData = [...review_list];
		}
		return newData;
	}, [galleyReview]);

	/////////////////////////////////////
	const handleCancelQa = useCallback(() => {
		setTimeout(() => {
			setShowQa(false);
		}, 300);
	}, []);
	const handleCancelReview = useCallback(() => {
		setShowReview(false);

		// setTimeout(() => {
		//   setClosing(false);
		//   setShowReview(false);
		// }, 300);
	}, []);

	/////////////////////////////////////
	const handleErrorGalley = () => {
		refetch();
	};

	/////////////////////////////////////
	useEffect(() => {
		if (galleyReview) {
			dispatch(
				setlistReviewGalley({
					data: galleyReview.items,
				})
			);
		}
	}, [galleyReview]);

	//////////////////////////////////////////
	return (
		<div id="nteam-comment">
			{contextHolder}
			{contextHolderNoti}
			{/* <CurrentRated item_id="1021595116" item_type="product"></CurrentRated>
			<CurrentRated item_id="1021595116" item_type="product"></CurrentRated> */}

			<Row
				gutter={[
					{ sm: 0, md: 0, xs: 0 },
					{ sm: 24, md: 40, xs: 24 },
				]}
				style={{ margin: 0 }}>
				<Col span={24}>
					<div className="response_col_to_row">
						<Typography.Title
							id="h3_wrapper"
							style={{ fontWeight: 400, marginBottom: 16 }}
							level={3}>
							Câu hỏi thường gặp
						</Typography.Title>
						<span
							onClick={() => {
								setShowQa(true);
							}}
							style={{
								padding: 0,
								borderBottom: "1px solid #004B8F",
								color: "#004B8F",
								fontSize: "14px",
								fontWeight: 700,
								cursor: "pointer",
							}}>
							Đặt câu hỏi
						</span>
					</div>
					<QaList item_id={product_id} item_type={item_type}></QaList>
				</Col>

				<Col span={24}>
					<ListStarProcess
						dataSource={Array.from(new Array(5))}
						average={4.8}
						isLoading={false}
						number={600}
						item_type={item_type}
						item_id={product_id}
						text={" lượt đánh giá"}
						showReview={() => {
							setShowReview(true);
						}}></ListStarProcess>
				</Col>

				{galleyReview &&
					galleyReview.items.length > 0 &&
					dataReviewDefault.length > 0 && (
						<>
							<Col span={24}>
								<Row
									id="galley_title_wrapper"
									align={"middle"}
									justify={"space-between"}>
									<Col>
										<p className="galley_title" style={{ margin: 0 }}>
											Hình ảnh
										</p>
									</Col>
									<Col>
										<p
											className="galley_more"
											style={{ cursor: "pointer", margin: 0 }}
											onClick={() => setShowGallery(true)}>
											Xem tất cả hình ảnh
											<RightOutlined style={{ margin: "0 0 0 6px" }} />
										</p>
									</Col>
								</Row>
								<CommentSwiper
									classWrapper="comment_galley_wrapper"
									idSwiper="galley_list"
									initialSlide={0}
									dataSource={dataReviewDetailActive}
									isloading={false}
									error={erorrFetchGalley}
									handleError={handleErrorGalley}
									setButtonNext="swiper-button-galley-next"
									setButtonPrev="swiper-button-galley-prev"
									freeMode={{ enabled: true, momentum: true }}
									slidesPerGroup={3}
									// error={erorrFetchReview && erorrFetchReview}
									navigation={true}
									styleButton={{ width: "50px", height: "50px" }}
									styleButton_next={{ right: "-25px", border: "none" }}
									styleButton_prev={{ left: "-25px", border: "none" }}
									itemRender={(item: CommentJson, index) => (
										<CommentReviewItem
											key={item.id}
											item={item}
											index={index}
											data={dataReviewDetailActive}
											defaultIndexImage={handleRevertIndexImage}
											handleShowDetail={handleShowReviewDetail}
											setUrlImage={(url: string) => {}}></CommentReviewItem>
									)}
									autoplay={false}
									responsive={{
										xxs: { slidesPerView: 2.8, spaceBetween: 8 },
										xs: { slidesPerView: 3.2, spaceBetween: 8 },
										sm: { slidesPerView: 3.5, spaceBetween: 8 },
										md: { slidesPerView: 5.9, spaceBetween: 8 },
										lg: { slidesPerView: 6.2, spaceBetween: 8 },
										xl: { slidesPerView: 6.2, spaceBetween: 8 },
									}}></CommentSwiper>
							</Col>
						</>
					)}

				<Col span={24}>
					<CommentList
						borderOverFlow={false}
						classWrapper="comment_list_wrapper"
						labelLoadMore="Xem thêm"
						type_list="review"
						item_type={item_type}
						item_id={product_id}></CommentList>
				</Col>
			</Row>
			{/* Modal form login  */}
			<Modal
				destroyOnClose={true}
				// title="Login"
				closable={false}
				open={showLogin}
				onCancel={() => {
					dispatch(toggleShowLogin());
				}}
				centered
				okButtonProps={{ style: { display: "none" } }}
				zIndex={1010}
				maskStyle={{ zIndex: 1010 }}>
				<Login
					handleLoginSuccess={() => {
						messageApi.open({
							content: "Đăng nhập thành công",
							duration: 4,
							type: "success",
						});
						dispatch(toggleShowLogin());
					}}></Login>
				{/* <Register /> */}
			</Modal>
			{/* Modal galley image  */}
			<Modal
				key={"galley"}
				title="Tất cả hình ảnh"
				closable={true}
				open={showGallery}
				cancelText={"Đóng"}
				onCancel={() => {
					setShowGallery(false);
				}}
				centered
				wrapClassName="modal-review-wrapper modal_detail_review_wrapper"
				className={`modal_review modal_review_galley`}
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				width={1000}
				footer={null}
				destroyOnClose={true}
				rootClassName="scrollableDiv_review scrollableDiv_hide_operation"
				bodyStyle={{ marginTop: 16 }}
				transitionName="custom-transition"
				zIndex={1000}
				// forceRender={true}
			>
				<CommentGallery
					item_type={item_type}
					dataSource={dataReviewDetailActive}
					item_id={
						typeof product_id === "string"
							? product_id
							: JSON.stringify(product_id)
					}></CommentGallery>
			</Modal>
			{/* Modal form add Qa  */}
			<Modal
				key={"qa"}
				title="Đặt câu hỏi"
				closable={true}
				open={showQa}
				cancelText={"Đóng"}
				wrapClassName="modal-review-wrapper"
				className={`modal_qa modal_review`}
				onCancel={() => {
					setShowQa(false);
				}}
				centered
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				width={"100%"}
				destroyOnClose={true}
				rootClassName="scrollableDiv_review"
				zIndex={1002}
				footer={null}
				forceRender={true}
				transitionName="custom-transition">
				<CommentForm
					item_id={product_id}
					item_type={item_type}
					handleSuccess={handleSuccesQa}
					form_type="qa"
					handleCancelModal={handleCancelQa}></CommentForm>
			</Modal>
			{/* Modal form add review */}
			<Modal
				key={"review"}
				title={
					<Typography.Title level={5} style={{ margin: 0, fontSize: "24px" }}>
						Đánh giá sản phẩm
					</Typography.Title>
				}
				className={`modal_review`}
				centered
				closable={true}
				open={showReview}
				cancelText={"Đóng"}
				onCancel={() => {
					setShowReview(false);

					// setTimeout(() => {
					//   setShowReview(false);
					// }, 100);
				}}
				// modalRender={(node) => <div>sdf</div>}
				wrapClassName={`modal-review-wrapper  ${
					showReview ? "modal_show" : ""
				}`}
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				width={540}
				destroyOnClose={true}
				rootClassName="scrollableDiv_review"
				forceRender={false}
				transitionName="custom-transition"
				footer={null}
				zIndex={1002}
				// maskTransitionName="none"
				// maskTransitionName="none"
			>
				{/* {delayDetroy && ( */}
				<CommentForm
					item_id={product_id}
					item_type={item_type}
					handleSuccess={handleSuccesReview}
					form_type="review"
					handleCancelModal={handleCancelReview}></CommentForm>
				{/* )} */}
			</Modal>
			{/* Modal reiview detail  */}
			<Modal
				wrapClassName="review-detail-modal modal-review-wrapper"
				closable={true}
				open={showReviewDetail}
				cancelText={"Đóng"}
				className={`modal_reviewDetail`}
				onCancel={() => {
					setShowReviewDetail(false);
					setDefaultSlideReview(0);
					// setTimeout(() => {
					// }, 500);
				}}
				centered
				okButtonProps={{ style: { display: "none" } }}
				cancelButtonProps={{ style: { display: "none" } }}
				width={"881px"}
				destroyOnClose={true}
				rootClassName="scrollableDiv_review "
				forceRender={false}
				getContainer={false}
				transitionName="custom-transition"
				footer={null}
				zIndex={1002}>
				{dataReviewDetailActive.length > 0 && (
					<ReviewDetail
						dataSource={dataReviewDetailActive}
						// dataReviewDetail={dataReviewDetail}
						visible={showReviewDetail}
						defaultIndexSlide={defaultSlideReview}
						defaultIndexImageFunc={handleRevertIndexImage}
						// defaultIndexImg={defaultIndexImg}
						// defaultImageItem={}
						showLinkMore={true}
						handleShowMore={() => {
							setShowReviewDetail(false);
							setDefaultSlideReview(0);
							setShowGallery(true);
						}}></ReviewDetail>
				)}
			</Modal>
		</div>
	);
};

export default Comment;
